import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CardProfile from '../../../components/Profile/Card';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { isMobile } from 'react-device-detect';
import ScheduleForm from '../../../components/Forms/Perfil/ScheduleForm';
import ScheduleView from '../../../components/Profile/Schedule/ScheduleView';
import Snackbar from '../../../components/Snackbar';
import TrophieModal from '../../../components/Modal/TrophieModal';

var Scroll = require('react-scroll');
var Element = Scroll.Element;

const useStyles = makeStyles(() => ({
  formControl: {
    maxWidth: '100%',
  },
  radioGroup: {
    flexDirection: 'row',
  },
  label: {
    fontWeight: 'bold',
    color: '#484848',
  },
}));

export const Schedule = ({ authClient, trophie, membershipType }) => {
  const classes = useStyles();
  const scheduleDays = authClient.schedule && authClient.schedule.scheduleDays;

  const [typeSchedule, setTypeSchedule] = useState(authClient.schedule && authClient.schedule.type || "continuous");
  const [showForm, setShowForm] = useState(true);
  const [flagEdit, setFlagEdit] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success'
  });
  const [ openTrophieModal, setOpenTrophieModal ] = useState(false);

  useEffect(()=>{
    if(flagEdit){
      setTypeSchedule(authClient.schedule && authClient.schedule.type)
    }
  }, [flagEdit])

  
  const handleChange = (event) => {
    setTypeSchedule(event.target.value);
  };

  const handleEdit = () => {
    setFlagEdit(flagEdit? false:true)
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success'
    });
  };

  const handleOpenTrophieModal = () => {
    setOpenTrophieModal(true);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
    setFlagEdit(false);
  };

  return (
    <div className="schedule">
      <Element name="TopSchedule">
        <CardProfile
          title={'Horarios de servicio'}
          subTitle={
            authClient.role === 'lawyer'
              ? 'Publica tus horarios de servicio.'
              : 'Publica los horarios de servicio del despacho.'
          }
          awardIcon
          status={
            authClient && authClient.awardPerfil && authClient.awardPerfil.schedule
              ? authClient.awardPerfil.schedule
              : false
          }
        >
          {(!scheduleDays || flagEdit) ? (
            <>
              <p
                style={{
                  marginBottom: 32,
                  fontWeight: 'bold',
                  color: '#484848'
                }}
              >
                Agrega los horarios de atención
              </p>

              <FormControl
                component="fieldset"
                fullWidth
                classes={{ root: classes.formControl }}
              >
                <RadioGroup
                  aria-label="scheduleType"
                  name="scheduleType"
                  value={typeSchedule}
                  onChange={handleChange}
                  classes={{ root: classes.radioGroup }}
                >
                  <div>
                    <FormControlLabel
                      value="continuous"
                      control={<Radio color="secondary" />}
                      label="Horario continuo"
                      classes={{ label: classes.label }}
                      
                    />
                    {isMobile && (
                      <p
                        style={{
                          color: '#484848',
                          marginLeft: 33
                        }}
                      >
                        Esta opción solo permite establecer un horario corrido.
                      </p>
                    )}
                  </div>
                  <div>
                    <FormControlLabel
                      value="divided"
                      control={<Radio color="secondary" />}
                      label="Horario seccionado"
                      classes={{ label: classes.label }}
                    />
                    {isMobile && (
                      <p style={{color: '#484848', marginLeft: 33}}>
                        Esta opción solo permite establecer un horario dividido.
                      </p>
                    )}
                  </div>
                </RadioGroup>
              </FormControl>
              {!isMobile && (
                <p
                  style={{
                    marginBottom: 32,
                    color: '#484848',
                  }}
                >
                  {typeSchedule === 'continuous'
                    ? 'Esta opción solo permite establecer un horario corrido.'
                    : 'Esta opción solo permite establecer un horario dividido.'}
                </p>
              )}

              <ScheduleForm 
                typeSchedule={typeSchedule} 
                setFlagEdit={setFlagEdit} 
                flagEdit={flagEdit} 
                setFeedbackMessage={setFeedbackMessage} 
                handleOpenTrophieModal={handleOpenTrophieModal}
              />
                
            </>
          ): null}

          {scheduleDays && !flagEdit ? 
            (<div style={{marginLeft: isMobile? 0 : 40}}>
              <ScheduleView optionsButton editSchedule={handleEdit} />
            </div>) : null
          
          }
        </CardProfile>

      </Element>
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title='Horarios de servicio'
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Al agregar un horario de servicio, los clientes se sentirán más seguros al contactarte'
      /> 
    </div>
  );
};

const mapStateToProps = (state) => ({
  authClient: state.authClient,
  trophie: state.authClient.awardPerfil.schedule,
  membershipType: state.authClient.membership.type
  //scheduleDays: state.authClient.schedule.scheduleDays,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
